import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./user"; // Make sure this import is correct
import { messageSlice } from "./redux/reducers/message"; // Make sure this import is correct

const reducer = {
  user: userSlice.reducer, // Access the 'reducer' property of the userSlice
  message: messageSlice.reducer
};

const store = configureStore({
  reducer: reducer,
  devTools: true,
});

export default store;
